import FormSelectInput from 'components/forms/elements/FormSelectInput'
import FormTextInput from 'components/forms/elements/FormTextInput'
import RelayEventInput from 'components/forms/utils/RelayEventInput'
import shirtFieldInputs from 'components/forms/utils/shirtFieldInputs'
import SubCategoryInput from 'components/forms/utils/SubCategoryInput'
import { ALL_TSHIRT_SIZES, TSHIRT_SIZES } from 'constants/models'
import { isCategoryRelay } from 'utils/ApiHelpers'

interface CategoryProps {
  id: string
  name: string
  priority: number
  disabled?: boolean
}

const category = ({
  values,
  categories,
  onCategoryChange,

  currentRelayEvent,
  selectedRelayEvent,
  onRelayEventChange,

  fullShirtDetails,
  hasJersey,

  hasBibName,

  subCategories,

  formDisabled,
}) => [
  {
    id: 'categoryId',
    size: { sm: 12, md: 6 },
    field: (
      <FormSelectInput
        name="categoryId"
        label="Category"
        autoComplete="new-categoryId"
        disabled={formDisabled}
        placeholder="Select Category"
        options={categories
          .sort((a: CategoryProps, b: CategoryProps) => {
            if (!!a.priority && !b.priority) return -1
            if (!!b.priority && !a.priority) return 1
            return a.priority - b.priority
          })
          .map((category: CategoryProps) => ({
            value: category.id,
            text: category.name,
            disabled: category.disabled,
          }))}
        onModified={onCategoryChange}
        required
      />
    ),
  },
  {
    ...(isCategoryRelay(values) && {
      id: 'relayEvent',
      size: { sm: 12, md: 6 },
      field: (
        <RelayEventInput
          values={values}
          currentRelayEvent={currentRelayEvent}
          selectedRelayEvent={selectedRelayEvent}
          formDisabled={formDisabled}
          onRelayEventChange={onRelayEventChange}
        />
      ),
    }),
  },
  ...shirtFieldInputs({ key: 1, fullShirtDetails, formDisabled }),
  ...shirtFieldInputs({ key: 2, fullShirtDetails, formDisabled }),
  {
    ...(hasJersey &&
      (values.isIndividual || values.relayEvent.includes('BIKE')) && {
        id: 'jerseySize',
        size: { sm: 12, md: 6 },
        field: (
          <FormSelectInput
            name="jerseySize"
            label={`${
              fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
            } size`}
            autoComplete="new-jerseySize"
            placeholder={`Select ${
              fullShirtDetails.shirtDetails?.JERSEY?.LABEL || 'Cycling jersey'
            } size`}
            disabled={formDisabled}
            // options={Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
            //   value: key,
            //   text: value,
            // }))}
            options={
              `JERSEY` in fullShirtDetails.shirtDetails &&
              'SIZE_OPTIONS' in fullShirtDetails.shirtDetails.JERSEY
                ? fullShirtDetails.shirtDetails.JERSEY.SIZE_OPTIONS.map(
                    (value: string) => ({
                      value,
                      text: ALL_TSHIRT_SIZES[value],
                    }),
                  )
                : Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
                    value: key,
                    text: value,
                  }))
            }
            required
          />
        ),
      }),
  },
  {
    id: 'teamName',
    size: { sm: 12, md: 6 },
    field: (
      <FormTextInput
        name="teamName"
        label="Team Name"
        autoComplete="new-teamName"
        disabled={formDisabled}
      />
    ),
  },
  {
    ...(hasBibName && {
      id: 'bibName',
      size: { sm: 12, md: 6 },
      field: (
        <FormTextInput
          name="bibName"
          label="Name in bib"
          autoComplete="new-bibName"
          disabled={formDisabled}
        />
      ),
    }),
  },

  {
    ...(subCategories &&
      Object.keys(subCategories).length > 0 && {
        id: 'subCategory',
        size: { sm: 12, md: 6 },
        field: (
          <SubCategoryInput
            subCategories={subCategories}
            formDisabled={formDisabled}
          />
        ),
      }),
  },
]

export default category
